import { NgModule } from '@angular/core';
import { LetDirective } from './let.directive';

@NgModule({
  declarations: [LetDirective],
  imports: [],
  exports: [LetDirective]
})
export class LetDirectiveModule {}
